module.exports = {"640106001":"满城北街街道","640106002":"黄河东路街道","640106003":"长城中路街道","640106004":"北京中路街道","640106005":"上海西路街道","640106100":"良田镇","640106101":"丰登镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640106.json
// module id = 3028
// module chunks = 0